import React from 'react';
import Loading from '@components/common/loading';
import useLocale from '@hooks/useLocale';
import AppLoading from '@modules/main/AppLoading';
import AppRoutes from '@routes/routes';
import { ConfigProvider } from 'antd';
import deDE from 'antd/locale/de_DE';
import enUS from 'antd/locale/en_US';
import viVN from 'antd/locale/vi_VN';

const antdLocales = { de: deDE, en: enUS, vi: viVN };

const App = () => {
    const { locale } = useLocale();

    return (
        <ConfigProvider
            locale={antdLocales[locale] || enUS}
            theme={{
                token: {
                    colorPrimary: '#1677ff',
                    borderRadius: 9,
                    fontFamily: "'Manrope', 'Segoe UI', Arial, sans-serif",
                },
            }}
        >
            <React.Suspense fallback={<Loading show />}>
                <AppLoading />
                <AppRoutes />
            </React.Suspense>
        </ConfigProvider>
    );
};

export default App;
